import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { DataService } from '../../common-services/data.service';
import { SharedService } from '../../common-services/shared.service';
import { HeaderService } from './header-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() isLoginHeader: boolean = true;
  userFullName: string = sessionStorage.getItem('username') ? sessionStorage.getItem('username') : null;
  isFullScreen: boolean = false;
  username: string = sessionStorage.getItem('username') ? sessionStorage.getItem('username') : 'unknown';
  userRole: string = sessionStorage.getItem('role') ? sessionStorage.getItem('role') : 'unknown';
  refreshTime: any = this._datePipe.transform(Date.now(), 'EEEE, MMMM d, y, h:mm:ss a zzzz');
  timeZone: string = moment.tz.guess();
  tenantList: any[] = [];
  selectedTenant = new FormControl();
  private _subscription: Subscription;
  private _loginSubscription: Subscription;
  @HostListener('document:fullscreenchange', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!document?.fullscreenElement) {
      this.isFullScreen = !this.isFullScreen;
    }
  }

  constructor(
    private _router: Router,
    private _headerService: HeaderService,
    public sharedService: SharedService,
    private _datePipe: DatePipe,
    private _dataService: DataService
  ) {
    this._subscription = this._dataService?.events?.subscribe((res: any) => {
      if (res?.name === 'tenantsListStored') {
        this.setHeaderTenant();
      }
    });
  }

  ngOnInit() {
    this.setHeaderTenant();
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._loginSubscription?.unsubscribe();
  }

  /**
   * Sets header tenant
   */
  setHeaderTenant() {
    const storedTenantList = localStorage.getItem('tenantList');
    this.tenantList = storedTenantList ? JSON.parse(storedTenantList) : [];
    const selectedTenantId = JSON.parse(sessionStorage.getItem('tenantId'));
    if (selectedTenantId) {
      if (this.tenantList?.length) {
        const filteredTenant = this.tenantList.find((item: any) => item?._id === selectedTenantId);
        this.selectedTenant.setValue(filteredTenant);
      }
    }
    else if (this.tenantList?.length) {
      this.selectedTenant.setValue(this.tenantList[0]);
    }
  }

  /**
   * Logouts header component
   */
  logout() {
    this._loginSubscription = this._headerService.logout(this.username).subscribe((res: any) => {
      if (res['status']) {
        if (res['response']) {
          this.sharedService.toastrHandler({ type: 'success', msg: res['response']['message'] });
          this.sharedService.resetRbac();
          localStorage.clear();
          sessionStorage.clear();
          this._router.navigateByUrl('user-authentication/login');
        } else {
          this.sharedService.toastrHandler({ type: 'error', msg: res['response']['message'] });
        }
      } else {
        this.sharedService.toastrHandler({ type: 'error', msg: res['response']['message'] });
      }
    },
    );
  }

  /**
   * toggle screen size
   */
  fullScreen() {
    if (!this.isFullScreen) {
      document.documentElement.requestFullscreen();
      this.isFullScreen = !this.isFullScreen;
    } else {
      document.exitFullscreen();
    }
  }

  /**
   * Toggles sidenav
   */
  toggleSidenav() {
    if (this.isLoginHeader) {
      this._headerService.setToggleButtonClick('sub');
    } else {
      this._headerService.setToggleButtonClick('clicked');
    }
  }

  /**
   * Apis refresh
   */
  apiRefresh() {
    this._dataService.broadcast('apiRefresh');
    this.refreshTime = this._datePipe.transform(Date.now(), 'EEEE, MMMM d, y, h:mm:ss a zzzz');
  }

  /**
   * Tenants change
   * @param event 
   */
  tenantChange(event: any) {
    sessionStorage.setItem('tenantId', JSON.stringify(event.value ? event?.value._id : null));
    this._dataService.broadcast('tenantChanged', event.value);
  }
}
